<template>
  <div class="theme-page min-h-screen pb-7">
    <div v-if="ui.reloadRequired" class="theme-reload-banner fixed top-0 left-0 right-0 z-[105] backdrop-blur-sm">
      <div class="mx-auto flex max-w-6xl flex-col gap-2 px-3 py-2 sm:flex-row sm:items-center sm:justify-between">
        <p class="font-mono text-xs theme-info">{{ ui.reloadMessage }}</p>
        <button @click="reloadApp" class="terminal-btn text-xs self-start sm:self-auto">Reload</button>
      </div>
    </div>
    <router-view />
    <footer class="theme-footer fixed bottom-0 left-0 right-0 z-[100] h-7 backdrop-blur-sm">
      <div class="h-full flex items-center justify-center gap-3 px-2 text-[11px] leading-none font-mono theme-muted">
        <span :title="`Commit date: ${buildInfo.date}`">Deployment: {{ buildInfo.shortSha }}</span>
        <span aria-hidden="true" class="theme-footer-divider">|</span>
        <span>v.{{ buildInfo.version }}</span>
        <span aria-hidden="true" class="theme-footer-divider">|</span>
        <a :href="CHANGELOG_URL" target="_blank" rel="noopener noreferrer" class="theme-info hover:opacity-80 transition-opacity">
          Log
        </a>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
import buildInfo from 'virtual:build-info';
import { useUiStore } from './stores/ui';
import { CHANGELOG_URL } from './config';

const ui = useUiStore();
function reloadApp() {
  window.location.reload();
}
</script>
